import { useState } from 'react';
import PropTypes from 'prop-types';
import { BsPlusLg, BsChevronRight, BsThreeDots } from 'react-icons/bs';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Button } from 'ypf-pas-general-ui-components';
import './FloatingButton.scss';

const FloatingButton = (props) => {
  const { onClick, variant, colorIcon, isOpen, children } = props;

  const [open, setOpen] = useState(false);

  return (
    <OverlayTrigger
      delay={{
        show: 250,
        hide: 400
      }}
      overlay={!isOpen ? <Tooltip id="button-tooltip">Agregar una SDS</Tooltip> : <></>}
      placement="top"
    >
      <div className="floating-actions">
        {open && <div className="floating-actions-content">{children}</div>}
        <Button
          className="floating-actions-button"
          colorIcon={colorIcon}
          // eslint-disable-next-line no-nested-ternary
          icon={isOpen && open ? BsChevronRight : isOpen ? BsThreeDots : BsPlusLg}
          onClick={isOpen ? () => setOpen(!open) : onClick}
          type="button"
          variant={variant}
          widthButton="60px"
        />
      </div>
    </OverlayTrigger>
  );
};

FloatingButton.propTypes = {
  onClick: PropTypes.func,
  variant: PropTypes.string,
  colorIcon: PropTypes.string,
  isOpen: PropTypes.bool,
  children: PropTypes.element
};

FloatingButton.defaultProps = {
  onClick: () => {},
  variant: 'primary',
  colorIcon: 'light',
  isOpen: false,
  children: <></>
};

export default FloatingButton;
